import React, { useEffect, useState } from "react";
import { Card, Typography, Button, Space, Rate, Dropdown, Menu } from "antd";
import { ArrowRightOutlined, CalendarOutlined } from "@ant-design/icons";
import DashboardDateFilter from "./DashboardDateFilter";
import { RootState, useAppDispatch } from "../redux-toolkit/store/store";
import { useSelector } from "react-redux";
import { calculateReliefMethodEffectiveness } from "../redux-toolkit/slices/dashboardSlice";
import { formatDateInMMDDYYYY, formatDateToLongString } from "../helpers/date";

const { Title, Text } = Typography;

const DashboardReliefMethods = () => {
  const [filter, setFilter] = useState<string>("7");

  const dispatch = useAppDispatch();
  const {
    isError,
    isReliefEffectiveAverageLoading,
    reliefEffectivenessAverage,
  } = useSelector((state: RootState) => state.dashboard);
  useEffect(() => {
    dispatch(calculateReliefMethodEffectiveness(filter));
  }, []);
  const onFilterChange = (filter: string) => {
    setFilter(filter);
    dispatch(calculateReliefMethodEffectiveness(filter));
  };
  // const methods = [
  //   { name: "Twinge cream", date: "18 July 2024", rating: 4, unlockable: true },
  //   { name: "Medication", date: "10 June 2024", rating: 4 },
  //   { name: "Rest", date: "01 June 2024", rating: 4 },
  //   { name: "Rest", date: "01 June 2024", rating: 4 },
  // ];

  return (
    <Card>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Space
          align="center"
          style={{ justifyContent: "space-between", width: "100%" }}
        >
          <Title level={3}>Most effective relief method</Title>

          <DashboardDateFilter value={filter} onChange={onFilterChange} />
        </Space>
        {reliefEffectivenessAverage.slice(0, 5).map((item) => {
          return (
            <Space
              key={item.reliefMethod}
              className="relief-method-group" /* Apply margin between groups */
              align="center"
              style={{ justifyContent: "space-between", width: "100%" }}
              size={0}
            >
              <Space direction="vertical" size={0}>
                <Text className="relief-method-name">{item.reliefMethod}</Text>
                <Text className="relief-method-date">
                  Last used :{" "}
                  {formatDateInMMDDYYYY(new Date(item.lastRecordedDate))}
                </Text>
              </Space>

              <Space align="center">
                <Rate
                  allowHalf
                  defaultValue={item.averageEffectiveness}
                  count={5}
                  disabled
                  style={{ color: "#18373E" }}
                />
                <Text style={{ color: "#1E1E1E" }}>
                  {item.averageEffectiveness}/5
                </Text>
              </Space>
            </Space>
          );
        })}
        <Button
          type="link"
          icon={<ArrowRightOutlined />}
          style={{ color: "#1E1E1E", paddingLeft: 0 }}
        >
          View More
        </Button>
      </Space>
    </Card>
  );
};

export default DashboardReliefMethods;
/**
 * 
 * 
        {methods.map((method, index) => (
          <Space
            key={index}
            className="relief-method-group"
            align="center"
            style={{ justifyContent: "space-between", width: "100%" }}
            size={0} 
          >
            <Space direction="vertical" size={0}>
              <Text className="relief-method-name">{method.name}</Text>
              <Text className="relief-method-date">
                Last used : {method.date}
              </Text>
            </Space>
            {method.unlockable ? (
              <Button>Order to unlock effective rating</Button>
            ) : (
              <Space align="center">
                <Rate
                  allowHalf
                  defaultValue={method.rating}
                  count={5}
                  disabled
                  style={{ color: "#18373E" }}
                />
                <Text style={{ color: "#1E1E1E" }}>{method.rating}/5</Text>
              </Space>
            )}
          </Space>
        ))}

 */
